"use strict";
var setToStringTag = require("../internals/set-to-string-tag");
setToStringTag(Math, "Math", true);
